import { useMutation } from '@tanstack/react-query'

import { requestHouseShipmentCancellation } from './houseShipmentsV2Service'

export const useRequestHouseShipmentCancellation = () => {
  return useMutation({
    mutationFn: requestHouseShipmentCancellation,
  })
}
